"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Message = _interopRequireDefault(require("./components/Message/Message"));

var _TextArea = _interopRequireDefault(require("./components/TextArea/TextArea"));

var _Loader = _interopRequireDefault(require("./components/Loader/Loader"));

var _SendButton = _interopRequireDefault(require("./components/SendButton/SendButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// import ChatbotInfoLabel from '../ChatbotInfoLabel/ChatbotInfoLabel';
var ChatbotMessenger = function ChatbotMessenger(_ref) {
  var postMessage = _ref.postMessage,
      chatLog = _ref.chatLog,
      displayMessage = _ref.displayMessage,
      initials = _ref.initials,
      linkTyC = _ref.linkTyC;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      userMessage = _useState2[0],
      setUserMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1]; // const [showInfoLabel, setShowInfoLabel] = useState(true);


  var textareaRef = (0, _react.useRef)(null);
  var chatLogRef = (0, _react.useRef)(null); // const textInfoLabel =
  //   'Hola soy GAIA tu nuevo asistente virtual! Pregúntame lo que necesites, estoy para ayudarte! Recuerda que siempre puedes hablar con un colega humano en la línea de Ayuda Y-Click: Internos: 85500 opción 7 y si estas fuera de YPF al 0810-1229681 opción 4';

  var openNewTabInfo = function openNewTabInfo() {
    // Esto no debería ir seteado acá hardcode
    // Pero para una solución urgente en prod se manda así.
    window.open(linkTyC, '_blank');
  };

  (0, _react.useEffect)(function () {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (chatLogRef.current) {
      chatLogRef.current.scrollTop = chatLogRef.current.scrollHeight;
    }
  }, [chatLog]);

  var adjustTextareaHeight = function adjustTextareaHeight() {
    var textarea = textareaRef.current;
    textarea.style.height = 'auto';
    textarea.style.height = "".concat(textarea.scrollHeight, "px");
  };

  var resetTextareaHeight = function resetTextareaHeight() {
    var textarea = textareaRef.current;
    textarea.style.height = 'auto';
  };

  var handleChange = function handleChange(event) {
    setUserMessage(event.target.value);
    adjustTextareaHeight();
  };

  var handleReset = function handleReset() {
    setUserMessage('');
    resetTextareaHeight();
  };

  var processUserMessage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var trimmedMessage, chatbotResponse, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              trimmedMessage = userMessage.trim();
              setIsLoading(true);
              displayMessage('user', userMessage);

              if (!(trimmedMessage !== '')) {
                _context.next = 21;
                break;
              }

              _context.prev = 4;
              _context.next = 7;
              return postMessage(trimmedMessage);

            case 7:
              chatbotResponse = _context.sent;
              message = chatbotResponse.message;
              displayMessage('chatbot', message);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              displayMessage('chatbot', _context.t0.message);

            case 15:
              _context.prev = 15;
              setIsLoading(false);
              handleReset();
              textareaRef.current.focus();
              return _context.finish(15);

            case 20:
              setUserMessage('');

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12, 15, 20]]);
    }));

    return function processUserMessage() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleKeyPress = function handleKeyPress(event) {
    // if (event.key === 'Enter' && !event.shiftKey) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (isLoading || userMessage.trim() === '') return;
      processUserMessage();
      handleReset();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__ChatLog",
    ref: chatLogRef
  }, chatLog.length ? chatLog.map(function (message) {
    return /*#__PURE__*/_react.default.createElement(_Message.default, {
      key: message.id,
      message: message,
      initials: initials
    });
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__InputArea "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__InputArea-textarea "
  }, /*#__PURE__*/_react.default.createElement(_TextArea.default, {
    userMessage: userMessage,
    handleChange: handleChange,
    handleKeyPress: handleKeyPress,
    textareaRef: textareaRef,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__InputArea-textarea-sendButton "
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.default, null) : /*#__PURE__*/_react.default.createElement(_SendButton.default, {
    disabled: userMessage.trim() === '',
    processUserMessage: processUserMessage,
    handleReset: handleReset
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "Chatbot__Messenger__InputArea-linkToS",
    onClick: openNewTabInfo
  }, "T\xE9rminos y Condiciones de Uso")));
};

var _default = ChatbotMessenger;
exports.default = _default;